module.exports = __webpack_public_path__ + "img/button_default_04.981af398.png";